// extracted by mini-css-extract-plugin
export default {"photoBox":"PhotoBlock_photoBox__ZnG0w","photoCarlog":"PhotoBlock_photoCarlog__TMLOC","icon":"PhotoBlock_icon__oAKp6","overlay":"PhotoBlock_overlay__gjliG"};